import React from 'react';
import { PropTypes } from 'prop-types';

const TrForMultiSelect = ({ item, values }) => {
  const renderValues = () => {
    if (values[item.key] && Object.keys(values).length > 0) {
      const stringValues = JSON.stringify(values[item.key]);

      return JSON.parse(stringValues).join(', ');
    }
    return 'N/A';
  };

  return (
    <tr>
      <td className="w-44 font-normal text-vamos-gray" valign="top"> {`${item.label}`}</td>
      <td valign="top">{renderValues(values)}</td>
    </tr>
  );
};

TrForMultiSelect.propTypes = {
  item: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
};

export default TrForMultiSelect;
